export type JoinSubmitOutcome = 'exists' | 'new' | 'check-failed';

interface JoinSubmitArgs {
  email: string;
  /** POST /auth/check-email-exists; rejects on a network error or a 429. */
  checkEmailExists: (email: string) => Promise<{ exists: boolean }>;
  /** The email belongs to an account: switch to the Sign in tab, no navigation. */
  onExists: (email: string) => void;
  /** Go to step 2 (/onboarding) as before. */
  onNew: (email: string) => void;
}

/**
 * The Join tab's submit (Asana 1219793876039315): wait for the existence
 * answer before moving on. An existing email goes to the Sign in tab; a new
 * one goes to step 2; a failed or rate-limited check also goes to step 2,
 * where the sign-up form's own 409 handling (option C) catches an existing
 * account.
 */
export async function submitJoinEmail({ email, checkEmailExists, onExists, onNew }: JoinSubmitArgs): Promise<JoinSubmitOutcome> {
  let exists = false;
  let checkFailed = false;
  try {
    exists = (await checkEmailExists(email)).exists === true;
  } catch {
    checkFailed = true;
  }
  if (exists) {
    onExists(email);
    return 'exists';
  }
  onNew(email);
  return checkFailed ? 'check-failed' : 'new';
}
